/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * Product area, shown as the pill on a card. Stored as its int, so never renumber a member -
renaming one is safe.1 = General

2 = ProjectManagement

3 = Financial

4 = Sales

5 = Communication

6 = Settings


 */
export type WhatsNewArea = (typeof WhatsNewArea)[keyof typeof WhatsNewArea];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WhatsNewArea = {
  General: 1,
  ProjectManagement: 2,
  Financial: 3,
  Sales: 4,
  Communication: 5,
  Settings: 6,
} as const;
